module.exports = __webpack_public_path__ + "img/Staff.6793fda4.png";